import { createClient } from '@supabase/supabase-js';
import { appConfig } from '../config/appConfig';

const url = appConfig.supabaseUrl;
const anonKey = appConfig.supabaseAnonKey;

if (!url || !anonKey) {
  throw new Error('supabaseUrl y supabaseAnonKey son requeridos (config montada en runtime o VITE_SUPABASE_* en .env)');
}

/**
 * Cliente de Supabase del sitio de afiliados. El afiliado entra con CUIL + contraseña;
 * la identidad en auth es un email sintético (ver utils/identity.ts). Lee solo por las
 * vistas vw_mi_* / vw_mis_* y escribe solo por RPC (ADR #048 y #049).
 */
export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
});
